export default __webpack_public_path__ + "static/media/suara.2163949b.jpg";